import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6acf97e2")

_pushScopeId("data-v-6acf97e2")
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Curbside Orders ")
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 0,
  id: "notification-badge",
  class: "message-count"
}
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_label = _resolveComponent("ion-label")
  const _component_ion_toggle = _resolveComponent("ion-toggle")
  const _component_pause_button = _resolveComponent("pause-button")
  const _component_ion_buttons = _resolveComponent("ion-buttons")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_header_alert = _resolveComponent("header-alert")
  const _component_ion_header = _resolveComponent("ion-header")

  return (_openBlock(), _createBlock(_component_ion_header, null, {
    default: _withId(() => [
      _createVNode(_component_ion_toolbar, null, {
        default: _withId(() => [
          _createVNode(_component_ion_button, {
            slot: "start",
            fill: "clear",
            class: "home-link",
            onClick: _ctx.handleHomeLink
          }, {
            default: _withId(() => [
              (!_ctx.isHome)
                ? (_openBlock(), _createBlock(_component_ion_icon, {
                    key: 0,
                    icon: _ctx.chevronBackSharp
                  }, null, 8, ["icon"]))
                : _createCommentVNode("", true),
              (_ctx.isHome)
                ? (_openBlock(), _createBlock(_component_ion_icon, {
                    key: 1,
                    icon: "menu-outline"
                  }))
                : _createCommentVNode("", true),
              _createVNode("div", {
                id: "header-title",
                textContent: _ctx.isHome ? _ctx.title : _ctx.backTitle
              }, null, 8, ["textContent"])
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode("div", {
            slot: "secondary",
            class: ["curbside-toggle", { hidden: !_ctx.isHome}]
          }, [
            _createVNode(_component_ion_label, null, {
              default: _withId(() => [
                _hoisted_1,
                (_ctx.showCurbside)
                  ? (_openBlock(), _createBlock("strong", _hoisted_2, "On"))
                  : _createCommentVNode("", true),
                (!_ctx.showCurbside)
                  ? (_openBlock(), _createBlock("strong", _hoisted_3, "Off"))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_ion_toggle, {
              id: "header-curbside-toggle",
              checked: _ctx.showCurbside,
              onIonChange: _ctx.toggleCurbside
            }, null, 8, ["checked", "onIonChange"])
          ], 2),
          _createVNode(_component_ion_buttons, { slot: "end" }, {
            default: _withId(() => [
              _createVNode(_component_pause_button, {
                class: "pause-button",
                "onOpen-pause-modal": _cache[1] || (_cache[1] = $event => (_ctx.$emit('open-pause-shop')))
              }),
              _createVNode("div", {
                id: "header-clock",
                class: "clock",
                textContent: _ctx.formattedTime
              }, null, 8, ["textContent"]),
              _createVNode(_component_ion_button, {
                onClick: _cache[2] || (_cache[2] = $event => (_ctx.$emit('open-search'))),
                class: "search-icon"
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_icon, { icon: _ctx.search }, null, 8, ["icon"])
                ]),
                _: 1
              }),
              (_ctx.configs.featureFlags().showHqMessages)
                ? (_openBlock(), _createBlock(_component_ion_button, {
                    key: 0,
                    id: "header-notifications",
                    onClick: _cache[3] || (_cache[3] = $event => (_ctx.$emit('notifications-toggle', true)))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, { icon: "/assets/icons/bell.svg" }),
                      (_ctx.hasHqMessages)
                        ? (_openBlock(), _createBlock("div", _hoisted_4))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_header_alert, {
        message: _ctx.alertMessage,
        "button-text": _ctx.alertButtonText,
        "onAlert-click": _cache[4] || (_cache[4] = $event => (_ctx.$emit('alert-click')))
      }, null, 8, ["message", "button-text"])
    ]),
    _: 1
  }))
})